import script from "./VehicleDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleDetail.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleDetail.vue?vue&type=style&index=0&id=3d7cd091&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7cd091"]])

export default __exports__